import React from "react";

import Header from "./Header";
import Process from "../processes/Process";

export default function LayoutViewProcess({ editMode = false }) {
  return (
    <>
      <Header />
      <Process editMode={editMode} />
    </>
  );
}
